import {
  AssetPresentationFormEnum,
  AssetPresentationRatioEnum,
  createFakeCategoryTree,
  KuxErrorType,
  KuxFilteredCategoriesDTO,
  SpecialWidgetTypeEnum,
} from '@kaltura-ott/tvpil';

import { CollectionRailStoreV2, SearchRailStore } from '../category/widgets/rails';
import { EntitiesType } from '../entities';

export const createSearchGridRail = (
  searchTree: KuxFilteredCategoriesDTO,
  specialWidgetType: SpecialWidgetTypeEnum,
  kSql?: string,
  searchErrorHandler?: (error?: KuxErrorType) => void,
): CollectionRailStoreV2 => {
  switch (specialWidgetType) {
    case SpecialWidgetTypeEnum.recommendations: {
      const categoryTree = {
        ...searchTree,
        channels: [searchTree.searchProperty.recommendationsCollectionId],
        aggregatedKSQL: searchTree.aggregatedKSQL,
        specialWidgetType: SpecialWidgetTypeEnum.recommendations,
      };
      return new CollectionRailStoreV2(categoryTree, createFakeCategoryTree());
    }

    case SpecialWidgetTypeEnum.search: {
      const categoryTree = {
        ...searchTree,
        channels: searchTree.channels,
        aggregatedKSQL: String(kSql),
        specialWidgetType: SpecialWidgetTypeEnum.search,
      };
      return new SearchRailStore(categoryTree, createFakeCategoryTree(), undefined, true, searchErrorHandler);
    }

    case SpecialWidgetTypeEnum.cast: {
      const categoryTree = {
        ...searchTree,
        railImageProperty: {
          assetImageHeight: searchTree.railImageProperty.assetImageHeight,
          assetPresentationRatio: AssetPresentationRatioEnum['1x1'],
          assetPresentationForm: AssetPresentationFormEnum.circle,
        },
        channels: [] as number[],
        aggregatedKSQL: String(kSql),
        specialWidgetType: SpecialWidgetTypeEnum.cast,
      };
      return new CollectionRailStoreV2(categoryTree, createFakeCategoryTree());
    }
    default: {
      throw new Error(`${specialWidgetType} - wrong rail`);
    }
  }
};

// https://kaltura.atlassian.net/browse/KUXEXT-22532?focusedCommentId=1317812
export const isExistsInSearchHistory = (
  asset: EntitiesType,
  fullHistory: EntitiesType[],
  maxSearchLength: number,
): boolean => {
  return !!fullHistory
    .slice(0, maxSearchLength)
    .find(
      (history) =>
        ('seriesId' in asset.data &&
          'seriesId' in history.data &&
          asset.data.seriesId &&
          asset.data.seriesId === history.data.seriesId) ||
        asset.id === history.id,
    );
};
